import React, { Component } from 'react';
import { Transition } from 'react-transition-group';

export class ProjectTransition extends Component {
    onEnter = node => {};

    onExit = node => {
        node.style.display = 'none';
    };

    render() {
        return (
            <Transition
                {...this.props}
                timeout={this.props.timeout}
                onEnter={this.onEnter}
                onEntered={this.onEntered}
                onExit={this.onExit}
                mountOnEnter={true}
                unmountOnExit={true}
            />
        );
    }
}

ProjectTransition.defaultProps = {
    timeout: {
        enter: 10,
        exit: 10
    }
};



// WEBPACK FOOTER //
// ./src/components/templates/home/transitions.js